import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const ValidateRouteAccess = (to, from, next) => {
  const user = Vue.$cookies.isKey('token_cred')
  // var isAuthenticated= false;
  if (user) {
    next()
  } else {
    next({ name: 'inicio' })
  }
}
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/Inicio.view.vue'),
      meta: {
        breadcrumb: [
        ]
      }
    },
    {
      path: '/Login',
      name: 'LoginView',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [
        ]
      }
    },
    {
      path: '/home',
      name: 'home',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Home' }
        ]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/home.view.vue')
    },
    {
      path: '/PrecalificadorDatos/:referencia?',
      name: 'PrecalificadorGralDatosView',
      // beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: false,
        breadcrumb: [
          { name: 'Precalificador Carga de Datos ' }
        ]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/PrecalificadorGralDatos.view.vue')
    },
    {
      path: '/Precalificador',
      name: 'PrecalificadorGralView',
      // beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: false,
        breadcrumb: [
          { name: 'Precalificador ' }
        ]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/Precalificador.view.vue')
    },
    // Module Administracion
    {
      path: '/Administracion/usuarios',
      name: 'ViewUser',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [{ name: 'Usuarios' }]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/administracion/users.view.vue')
    },
    {
      path: '/Administracion/Empresa',
      name: 'ViewCompany',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Informacion de la Empresa',
        breadcrumb: [{ name: 'Empresa' }]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/administracion/company.view.vue')
    },
    {
      path: '/Administracion/Colaboradores',
      name: 'ViewEmployee',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Colaboradores' }]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/administracion/employee.view.vue')
    },
    {
      path: '/Administracion/Roles',
      name: 'ViewRoles',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [{ name: 'Roles' }]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/administracion/roles.view.vue')
    },
    {
      path: '/Administracion/Roles/Permisos/Asignar/:id',
      name: 'ViewPermissionsRoleAssign',
      props: true,
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Asignar Permisos',
        breadcrumb: [
          { name: 'Administracion' }, { name: 'Rol' }, { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/rolePermissionsAssign.view.vue')
    },
    {
      path: '/Administracion/Permisos',
      name: 'ViewPermisos',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [{ name: 'Roles' }]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/administracion/permisos.view.vue')
    },
    // Module Administracion End
    {
      path: '/Clientes',
      name: 'ViewCustomers',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Clientes',
        breadcrumb: [
          { name: 'Clientes' }
        ]
      },
      component: () => import('./views/customer/customers.view.vue')
    },
    {
      path: '/Clientes/TipoCredito/:id',
      name: 'ViewTipoCreditoCustomer',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'CREDITO BANCARIO',
        breadcrumb: [
          { name: 'Clientes' },
          { name: 'Tipo de Credito Bancario' }
        ]
      },
      component: () => import('./views/customer/tipoCredito.view.vue')
    },
    {
      path: '/Clientes/TipoCredito/Fovissste/:id',
      name: 'ViewTipoCreditoFovisssteCustomer',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'CREDITO FOVISSSTE',
        breadcrumb: [
          { name: 'Clientes' },
          { name: 'Tipo de Credito Fovissste' }
        ]
      },
      component: () => import('./views/customer/tipoCreditoFovissste.view.vue')
    },
    {
      path: '/Clientes/Actividad/Economica/:id',
      name: 'ViewActividadEconomicaCustomer',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'ACTIVIDAD ECONOMICA',
        breadcrumb: [
          { name: 'Clientes' },
          { name: 'Actividad Economica' }
        ]
      },
      component: () => import('./views/customer/actividadEconomica.view.vue')
    },

    {
      path: '/Clientes/Precalificados',
      name: 'ViewCreditPrecalificadosCustomer',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Clientes Pre-calificados',
        breadcrumb: [
          { name: 'Clientes' },
          { name: 'Precalificados' }
        ]
      },
      component: () => import('./views/customer/customerPrecalificacion.view.vue')
    },
    {
      path: '/administracion/Bancos',
      name: 'ViewBanks',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Bancos',
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Bancos' }
        ]
      },
      component: () => import('./views/administracion/Banks.view.vue')
    },
    {
      path: '/administracion/Plazos',
      name: 'ViewDeadlines',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'Plazos de Bancos',
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Plazos' }
        ]
      },
      component: () => import('./views/administracion/Deadlines.view.vue')
    },
    {
      path: '/Usuario/Perfil',
      name: 'ViewProfile',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        name: 'PERFIL DE USUARIO',
        breadcrumb: [
          { name: 'Configuracion' },
          { name: 'Usuario' },
          { name: 'Perfil' }
        ]
      },
      component: () => import('./views/administracion/Profile.view.vue')
    },

    {
      path: '/Precalificador/Correos',
      name: 'ViewPrecalificadosEmail',
      beforeEnter: ValidateRouteAccess,
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Precalificador' },
          { name: 'Correos' }
        ]
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/CorreosSimulador.view')
    }
  ]
})
